import React, { createContext, useContext, useState, useEffect } from 'react'

const DEBUG_STORAGE_KEY = 'debugModeEnabled'

const DebugContext = createContext(null)

export function DebugProvider({ children }) {
  const [debugEnabled, setDebugEnabledState] = useState(() => {
    try {
      const stored = localStorage.getItem(DEBUG_STORAGE_KEY)
      return stored === null ? true : stored === 'true'
    } catch {
      return true
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(DEBUG_STORAGE_KEY, String(debugEnabled))
    } catch {}
  }, [debugEnabled])

  const setDebugEnabled = (value) => setDebugEnabledState(Boolean(value))

  return (
    <DebugContext.Provider value={{ debugEnabled, setDebugEnabled }}>
      {children}
    </DebugContext.Provider>
  )
}

export function useDebug() {
  const ctx = useContext(DebugContext)
  return ctx || { debugEnabled: false, setDebugEnabled: () => {} }
}
